import { defineMessages } from 'react-intl';

export default defineMessages({
  routePreferenceSettings: {
    id: 'app.components.RoutePreferenceSettings.routePreferenceSettings',
    defaultMessage: 'Route preferences',
  },
  routePreferenceDescription: {
    id: 'app.components.RoutePreferenceSettings.routePreferenceDescription',
    defaultMessage:
      'Here you can indicate on which routes you prefer to be assigned to, which routes are possible for you, but not preferred, and which routes are not possible for you at all.',
  },
  disfavored: {
    id: 'app.components.RoutePreferenceSettings.disfavored',
    defaultMessage: 'Rather not',
  },
  neutral: {
    id: 'app.components.RoutePreferenceSettings.neutral',
    defaultMessage: 'Neutral',
  },
  preferred: {
    id: 'app.components.RoutePreferenceSettings.preferred',
    defaultMessage: 'Preferred',
  },
  saveRoutePreferenceSettingsFailure: {
    id: 'app.components.RoutePreferenceSettings.saveRoutePreferenceSettingsFailure',
    defaultMessage: 'Saving route preferences failed!',
  },
});
